import React from "react";
import { useTranslation } from "react-i18next";
import { TableSearchEmptyIllustration } from "@dreamhub/designsystem/icons";
import { Button } from "@/components/ui/button";
import Text from "@/components/ui/text";

const TRANSLATION_PREFIX = "tables.emptyState";

interface IntegrationsNoResultsProps {
  onClearSearch: () => void;
}

const IntegrationsNoResults: React.FC<IntegrationsNoResultsProps> = ({
  onClearSearch
}) => {
  const { t } = useTranslation();

  return (
    <div
      className="flex w-full items-center justify-center gap-4 py-12"
      data-test="integrations-no-results"
    >
      <div className="w-[280px] [&>svg]:h-auto [&>svg]:w-full">
        <TableSearchEmptyIllustration />
      </div>
      <div className="flex flex-col gap-10">
        <div className="flex flex-col gap-6">
          <Text variant="lgSubtitle" className="normal-case">
            {t(`${TRANSLATION_PREFIX}.title`)}
          </Text>
          <Text variant="lgBodySecondary" className="w-[20rem]">
            {t(`${TRANSLATION_PREFIX}.searchDescription`)}
          </Text>
        </div>
        <Button
          size="lg"
          variant="secondary"
          onClick={onClearSearch}
          className="w-fit"
          data-test="integrations-clear-search"
        >
          {t(`${TRANSLATION_PREFIX}.clearSearch`)}
        </Button>
      </div>
    </div>
  );
};

export default IntegrationsNoResults;
